<template>
  <span>{{ formatted }}</span>
</template>

<script>
import { dateUtil } from "../../api/api";
export default {
  props: ["item"],
  computed: {
    formatted() {
      if (!this.item.date) return "-";
      const d = new Date(this.item.date);
      const dateOnly = d.getUTCHours() === 0 && d.getUTCMinutes() === 0;
      return dateUtil(d, !dateOnly, "-");
    },
  },
};
</script>
